import { useCallback, useEffect, useState } from "react";
import { useFetch } from "use-http";
import ChartJS, { type ChartConfiguration } from "chart.js/auto";
import Spinner from "app/components/shared/Spinner";
import { LoadingChart } from "app/components/analytics/shared/LoadingStates";
import classNames from "classnames";
import Chart from "../Chart/chart";

enum ChartSize {
  Small = "small",
  Large = "large",
}

interface Props {
  size: ChartSize;
  endpoint: string;
}

ChartJS.defaults.font.family =
  "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, sans-serif";

const AsyncChart = (props: Props) => {
  const [chartData, setChartData] = useState<ChartConfiguration>();
  const { get, response, loading, error } = useFetch(props.endpoint);

  const fetchChartData = useCallback(async () => {
    const data = await get();
    if (response.ok) {
      setChartData(data);

      // TODO: Perform Chart.js transformation here based on `type` rather than in the backend
    }
  }, [props.endpoint, get]);

  useEffect(() => {
    fetchChartData();
  }, [fetchChartData]);

  if (error) {
    return <div>There was an error loading the chart</div>;
  }

  return (
    <div
      className={classNames("flex justify-center items-center", {
        "w-[250px] h-[150px]": props.size === "small",
        "w-full h-[400px]": props.size === "large",
      })}
    >
      {loading && props.size === ChartSize.Large && (
        <LoadingChart barWidth="25px" />
      )}
      {loading && props.size === ChartSize.Small && <Spinner />}
      {!loading && chartData?.data && <Chart chartOptions={chartData} />}
    </div>
  );
};

export default AsyncChart;
